/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Stats_ExperienceInputs */

const en_home_stats_experience = /** @type {(inputs: Home_Stats_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`35 Years Experience`)
};

const fr_home_stats_experience = /** @type {(inputs: Home_Stats_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`35 ans d'expérience`)
};

/**
* | output |
* | --- |
* | "35 Years Experience" |
*
* @param {Home_Stats_ExperienceInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_stats_experience = /** @type {((inputs?: Home_Stats_ExperienceInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Stats_ExperienceInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_stats_experience(inputs)
	return fr_home_stats_experience(inputs)
});